
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/resync-reset-clear",
      function () {
        return require("private-next-pages/syncs/resync-reset-clear.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/resync-reset-clear"])
      });
    }
  